var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 24.5312C26.5066 24.5312 31.7812 19.2566 31.7812 12.75C31.7812 6.2434 26.5066 0.96875 20 0.96875C13.4934 0.96875 8.21875 6.2434 8.21875 12.75C8.21875 19.2566 13.4934 24.5312 20 24.5312Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.96875 42.6562C0.96875 33.5938 8.21875 24.5312 20 24.5312C31.7812 24.5312 39.0312 33.5938 39.0312 42.6562",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderProfile);
export default __webpack_public_path__ + "static/media/header_profile.18a9d2e2f2818e44fe8d645a798fb6f5.svg";
export { ForwardRef as ReactComponent };